import * as React from 'react'
import styled from 'styled-components'
import { Youtube, Twitter, Instagram, Copy } from '@styled-icons/feather'
import { useClipboard, useToasts } from '@geist-ui/react'
import { getShortenedAddress } from '../../../utils/address'

// ========================== Styled components ================================

const CreatorDiv = styled.div`
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  /* border-radius: 12px; */
  /* background: linear-gradient(rgb(55, 55, 55), rgb(25, 25, 25)); */
  /* border-color: #323232; */
  /* border-width: 1px; */
  /* border-style: solid; */
  /* padding: 6px 8px; */
  width: fit-content;
  cursor: pointer;

  // tablet
  @media (max-width: 62em) {
    /* padding: 7px; */
    font-size: 15px;
    border-radius: 14px;
  }

  // mobile
  @media (max-width: 43em) {
    /* padding: 6px; */
    font-size: 14px;
    border-radius: 12px;
  }
`

const Handle = styled.div`
  color: white;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  margin-left: 10px;
  margin-right: 5px;

  // mobile and tablet
  @media (max-width: 62em) {
    font-size: 14px;
  }
`

// ================================ Types ======================================

export enum SOCIAL_TYPE {
  ID,
  TWITTER,
  YOUTUBE,
  INSTAGRAM,
}

const TYPE_ICON_MAP = {
  [SOCIAL_TYPE.ID]: Copy,
  [SOCIAL_TYPE.TWITTER]: Twitter,
  [SOCIAL_TYPE.YOUTUBE]: Youtube,
  [SOCIAL_TYPE.INSTAGRAM]: Instagram,
}

type SocialButtonProps = {
  handle?: string
  type: SOCIAL_TYPE
}

// ========================== React component ==================================

const SocialButton = ({ handle, type }: SocialButtonProps): JSX.Element | null => {
  const { copy } = useClipboard()
  const Icon = TYPE_ICON_MAP[type]
  const [, setToast] = useToasts()

  const handleClick = (): void => {
    if (type === SOCIAL_TYPE.ID) {
      if (handle) {
        copy(handle)
        setToast({ text: `Address copied.`, type: 'success' })
      }
    } else if (type === SOCIAL_TYPE.TWITTER) {
      window.open(`https://www.twitter.com/${handle}`, '_blank')
    } else if (type === SOCIAL_TYPE.YOUTUBE) {
      window.open(`https://www.youtube.com/c/${handle}`, '_blank')
    } else if (type === SOCIAL_TYPE.INSTAGRAM) {
      window.open(`https://www.instagram.com/${handle}`, '_blank')
    }
  }

  if (!handle) {
    return null
  }

  return (
    <CreatorDiv onClick={handleClick}>
      <Icon size={20} fontWeight={700} />
      {type === SOCIAL_TYPE.ID && <Handle>{getShortenedAddress(handle)}</Handle>}
    </CreatorDiv>
  )
}

export default SocialButton
